import {kSystemIcons} from "../../../constants/icons";
import GlossarySearchLoader from "../../loaders/glossaryScreen/GlossarySearchLoader";
import GlossaryResearchClearButton from "../../buttons/glossaryScreen/GlossaryResearchClearButton";
import GlossaryResearchVerticalDivider from "../../dividers/glossaryScreen/GlossaryResearchVerticalDivider";
import GlossaryResearchModeButton from "../../buttons/glossaryScreen/GlossaryResearchModeButton";
import GlossaryLettersList from "../../lists/glossaryScreen/GlossaryLettersList";
import GlossaryResearchVoid from "../../voids/glossaryScreen/GlossaryResearchVoid";
import GlossaryTerms from "./GlossaryTerms";
import GlossaryGoToTopButton from "../../buttons/glossaryScreen/GlossaryGoToTopButton";
import {isNullOrUndefined} from "../../../services/Validator";
import SystemAppContentError from "../../errors/SystemAppContentError";
import SystemAppContentLoader from "../../loaders/SystemAppContentLoader";

export default function GlossaryCoreContent({ error,
                                              getTerms,
                                              isLoading,
                                              filteredTerms,
                                              terms,
                                              search,
                                              handleSearchChange,
                                              isSearching,
                                              isStrictMode,
                                              setIsStrictMode,
                                              scrollToLetter,
                                              debouncedSearch,
                                              refs,
                                              highlight,
                                              showScrollTop,
                                              scrollToTop }) {
    // Used in GlossaryContent to handle display of
    // core content like search bar and terms list

    // BUILD
    if (!isNullOrUndefined(error))
        return <SystemAppContentError error={error}
                                      isLoading={isLoading}
                                      retryCallback={() => getTerms()} />
    if (isLoading)
        return <SystemAppContentLoader />
    const displayedTerms = filteredTerms ?? terms;
    return (
        <div className={"w-full flex flex-col justify-start items-center"}>
            <div className="bg-backgroundLight5 w-full h-[44px] flex items-center space-x-[8px] border-[2px] border-backgroundLight7 rounded-[8px] mt-[16px] px-[4px]">
                <div className="select-none bg-backgroundLight6 w-[32px] h-[32px] flex justify-center items-center rounded-[4px]">
                    <i className="material-icons text-[20px] text-greyLight9">{kSystemIcons.search}</i>
                </div>
                <input className="bg-transparent flex-grow px-[4px] py-[2px] focus:outline-none"
                       type="text"
                       placeholder="Mot clé"
                       value={search}
                       onChange={(e) => handleSearchChange(e.target.value)} />
                {isSearching
                    ? <GlossarySearchLoader />
                    : <GlossaryResearchClearButton search={search}
                                                   onClear={() => handleSearchChange('')} /> }
                <GlossaryResearchVerticalDivider />
                <GlossaryResearchModeButton
                    isStrictMode={isStrictMode}
                    setIsStrictMode={setIsStrictMode}
                />
            </div>
            <GlossaryLettersList terms={displayedTerms}
                                 scrollToLetter={scrollToLetter} />
            {debouncedSearch.trim() !== "" && Object.keys(displayedTerms || {}).length === 0 && (
                <GlossaryResearchVoid />
            )}
            <GlossaryTerms refs={refs}
                           terms={displayedTerms}
                           highlight={highlight}
                           search={debouncedSearch} />
            {showScrollTop && <GlossaryGoToTopButton scrollToTop={scrollToTop} />}
        </div>
    );
}